/* eslint-disable linebreak-style */
import React from 'react';
import ProductList from './components/ProductList';

const Products = (props) => (
      <ProductList {...props} />
);

export default Products;
